(function () {
  'use strict';
  const LANGUAGES = ['fr', 'en', 'it', 'nl', 'pt-PT', 'de', 'es', 'br', 'wo', 'ln', 'cr', 'cr-signature', 'ndjuka', 'saramaka'];
  function normalizeLanguage(value) {
    const code = String(value || '').toLowerCase();
    if (code === 'pt' || code === 'pt-pt') return 'pt-PT';
    return LANGUAGES.includes(code) ? code : 'fr';
  }
  function resolveChoice(models, character, requestedLanguage) {
    const code = normalizeLanguage(requestedLanguage);
    const base = models.find(model => model.character === character && !model.origineLanguage);
    if (!base) return null;
    if (['wo', 'ln', 'cr-signature'].includes(code)) return ['mia', 'noah'].includes(character)
      ? {model:base, language:code, fellBack:false}
      : {model:base, language:'fr', fellBack:true};
    if (!['cr', 'ndjuka', 'saramaka'].includes(code)) return {model:base, language:code, fellBack:false};
    const cultural = models.find(model => model.character === character && model.origineLanguage === code);
    return cultural ? {model:cultural, language:code, fellBack:false} : {model:base, language:'fr', fellBack:true};
  }
  function validPreset(value) {
    if (['origine-mia-cr', 'origine-mia-ndjuka', 'origine-mia-saramaka', 'origine-noah-cr', 'origine-noah-ndjuka', 'origine-noah-saramaka'].includes(value)) return true;
    return /^cast-[a-z]+-(?:signature-outfit-0[1-9]|(?:hero|prince-princess)-outfit-0[12])$/.test(String(value || ''));
  }
  function formatMessage(template, values) {
    return String(template || '').replace(/\{\{\s*(name|top|bottom)\s*\}\}/g, (_, key) => String(values[key] || ''));
  }
  function initialize(root) {
    if (!root || root.dataset.eclatInitialized === 'true') return;
    const configNode = root.querySelector('[data-eclat-config]');
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    const models = Array.from(root.querySelectorAll('[data-eclat-model]'));
    const hero = root.querySelector('[data-eclat-hero-sticker] [data-eclat-sticker]');
    const heroImage = hero && hero.querySelector('[data-eclat-avatar]');
    const nameLabel = root.querySelector('[data-eclat-selected-name]');
    const story = root.querySelector('[data-eclat-story]');
    const price = root.querySelector('[data-eclat-price]');
    const priceLocales = {fr:'fr-FR',en:'en-US',it:'it-IT',nl:'nl-NL',pt:'pt-BR',de:'de-DE',es:'es-MX'};
    if (price && Number.isFinite(config.price)) {
      const locale = priceLocales[String(config.locale).split('-')[0]] || config.locale;
      price.textContent = new Intl.NumberFormat(locale, {style:'currency',currency:config.currency || 'EUR',currencyDisplay:'narrowSymbol'}).format(config.price / 100);
    }
    const language = root.querySelector('[data-eclat-language]');
    const status = root.querySelector('[data-eclat-status]');
    if (!heroImage || !language || !nameLabel || !status || !models.length) return;
    let refreshPicker = () => {};
    let layoutPreviews = {};
    try { layoutPreviews = JSON.parse(root.querySelector('[data-eclat-layout-previews]')?.textContent || '{}'); } catch (_) {}
    function updateLayoutPreview(text) {
      const selected = models.find(model => model.getAttribute('aria-pressed') === 'true');
      const version = root.querySelector('[name="properties[_eclat_version]"]')?.value;
      const orderLanguage = language.value === 'cr-signature' ? 'cr' : language.value;
      const sku = ['eclat', selected?.dataset.eclatPreset, orderLanguage, 'off'].join('|');
      const candidate = version === 'eclat-baby-sun-v1' && !fade?.checked
        && root.dataset.eclatFadeEnabled !== 'true' ? layoutPreviews[sku] : null;
      // Preserve the original preview on missing assets, unknown messages or errors.
      const preview = candidate && (!text || (candidate.top === text.top && candidate.bottom === text.bottom)) ? candidate : null;
      root.querySelectorAll('[data-eclat-sticker]').forEach(sticker => {
        const image = sticker.querySelector('.eclat-sticker__layout-preview');
        if (!image) return;
        if (!preview) {
          sticker.classList.remove('eclat-sticker--approved-layout');
          image.onload = null;
          image.removeAttribute('src');
          return;
        }
        if (image.getAttribute('src') !== preview.asset) {
          image.onload = () => updateLayoutPreview(text);
          image.onerror = () => sticker.classList.remove('eclat-sticker--approved-layout');
          image.src = preview.asset;
        }
        sticker.classList.toggle('eclat-sticker--approved-layout', image.complete && image.naturalWidth > 0);
      });
    }
    const fade = root.querySelector('[data-eclat-fade]');
    if (fade) {
      fade.checked = false;
      root.dataset.eclatFadeEnabled = 'false';
      fade.addEventListener('change', () => { root.dataset.eclatFadeEnabled = String(fade.checked); updateLanguage(false); });
    }
    function updateLanguage(announce) {
      const code = normalizeLanguage(language.value);
      const selected = models.find(model => model.getAttribute('aria-pressed') === 'true');
      const text = selected?.dataset.eclatOrigineLanguage ? config.origineMessages?.[code] : (code === 'it' && selected?.dataset.eclatAudience === 'girl' ? { ...config.languages[code], top: 'BIMBA A BORDO' } : config.languages[code]);
      const hint = root.querySelector('[data-eclat-language]')?.parentElement.querySelector('small');
      if (hint) hint.hidden = Boolean(selected?.dataset.eclatOrigineLanguage);
      if (!text || !text.top || !text.bottom) return;
      language.value = code;
      updateLayoutPreview(text);
      root.querySelectorAll('[data-eclat-sticker]').forEach(sticker => {
        sticker.querySelector('[data-eclat-top]').textContent = text.top;
        sticker.querySelector('[data-eclat-bottom]').textContent = text.bottom;
        sticker.setAttribute('aria-label', formatMessage(config.alt, {name:sticker.dataset.eclatName, top:text.top, bottom:text.bottom}));
      });
      // UX-091 accepts language through Shopify locale routes, not arbitrary query text.
      root.querySelectorAll('[data-eclat-personalize]').forEach(link => {
        const route = config.routes[code];
        const preset = link.dataset.eclatPreset;
        if (!route || !validPreset(preset)) { link.hidden = true; return; }
        link.setAttribute('href', route + '?clairatier_preset=' + encodeURIComponent(preset));
      });
      if (announce) status.textContent = hero.getAttribute('aria-label');
    }
    function selectModel(button, announce) {
      if (!models.includes(button) || !validPreset(button.dataset.eclatPreset)) return;
      const thumb = button.querySelector('img');
      if (!thumb || !thumb.getAttribute('src')) return;
      models.forEach(model => model.setAttribute('aria-pressed', String(model === button)));
      heroImage.src = thumb.getAttribute('src');
      root.querySelectorAll('[data-eclat-mini] [data-eclat-avatar]').forEach(image => { image.src = thumb.getAttribute('src'); });
      hero.dataset.eclatName = button.dataset.eclatName;
      root.querySelectorAll('[data-eclat-mini] [data-eclat-sticker]').forEach(sticker => { sticker.dataset.eclatName = button.dataset.eclatName; });
      nameLabel.textContent = button.dataset.eclatName;
      if (story) story.textContent = config.stories[button.dataset.eclatCharacter] || "";
      if (button.dataset.eclatOrigineLanguage) language.value = button.dataset.eclatOrigineLanguage;
      else if (['cr', 'ndjuka', 'saramaka'].includes(language.value) || (['wo', 'ln', 'cr-signature'].includes(language.value) && !['mia', 'noah'].includes(button.dataset.eclatCharacter))) language.value = normalizeLanguage(config.locale);
      updateLanguage(false);
      refreshPicker();
      if (announce) status.textContent = formatMessage(config.announcement, {name:button.dataset.eclatName});
    }
    models.forEach(button => button.addEventListener('click', () => selectModel(button, true)));
    const descriptors = models.map(button => ({character:button.dataset.eclatCharacter, origineLanguage:button.dataset.eclatOrigineLanguage, button}));
    function choose(character, code, announce) {
      const choice = resolveChoice(descriptors, character, code);
      if (!choice) return;
      language.value = choice.language;
      selectModel(choice.model.button, announce);
      if (choice.fellBack) status.textContent = root.querySelector('[data-eclat-picker-fallback]')?.textContent || status.textContent;
    }
    language.addEventListener('change', () => {
      const selected = models.find(model => model.getAttribute('aria-pressed') === 'true');
      choose(selected?.dataset.eclatCharacter, language.value, false);
      updateLanguage(true);
      refreshPicker();
    });
    const template = root.querySelector('[data-eclat-picker-template]');
    if (template) {
      const panel = root.querySelector('.eclat__model-anchor');
      const grid = panel.querySelector('.eclat__models');
      const reviewLink = root.querySelector('.eclat__copy > .eclat__link');
      if (reviewLink) reviewLink.before(panel);
      const picker = template.content.cloneNode(true);
      panel.insertBefore(picker, panel.firstChild);
      const mini = panel.querySelector('[data-eclat-mini]');
      const miniature = hero.cloneNode(true);
      const ids = new Map();
      miniature.querySelectorAll('[id]').forEach(node => { ids.set(node.id, node.id + '-picker'); node.id += '-picker'; });
      miniature.querySelectorAll('*').forEach(node => {
        for (const attribute of Array.from(node.attributes)) {
          let value = attribute.value;
          ids.forEach((replacement, id) => { value = value.replaceAll('url(#' + id + ')', 'url(#' + replacement + ')'); if (value === '#' + id) value = '#' + replacement; });
          if (value !== attribute.value) node.setAttribute(attribute.name, value);
        }
      });
      mini.prepend(miniature);
      const form = root.querySelector('[data-eclat-purchase]');
      const buy = form?.querySelector('[data-eclat-buy]');
      const miniBuy = mini.querySelector('button');
      if (buy) {
        miniBuy.textContent = buy.textContent;
        miniBuy.addEventListener('click', () => buy.click());
        new MutationObserver(() => { miniBuy.disabled = buy.disabled; }).observe(buy, {attributes:true,attributeFilter:['disabled']});
      }
      const languageArea = language.closest('.eclat__language');
      panel.append(languageArea);
      const languages = panel.querySelector('[data-eclat-language-buttons]');
      languageArea.append(languages);
      if (form) panel.append(form);
      const choices = descriptors.filter(model => !model.origineLanguage).map(model => {
        const button = model.button.cloneNode(true);
        button.removeAttribute('data-eclat-model');
        button.removeAttribute('data-eclat-preset');
        button.removeAttribute('data-shopify-editor-block');
        button.dataset.eclatCharacterChoice = model.character;
        button.addEventListener('click', () => choose(model.character, language.value, true));
        grid.append(button);
        return button;
      });
      const languageButtons = Array.from(language.options).map(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'eclat__filter';
        button.dataset.eclatLanguageChoice = option.value;
        button.textContent = option.textContent;
        button.addEventListener('click', () => { language.value = option.value; language.dispatchEvent(new Event('change', {bubbles:true})); });
        languages.append(button);
        return button;
      });
      let audience = 'all';
      const search = panel.querySelector('[data-eclat-search]');
      grid.before(search.closest('label'));
      grid.after(panel.querySelector('[data-eclat-empty]'));
      const stickyHeader = document.querySelector('.header-sticker__inner');
      if (stickyHeader) {
        const updateOffset = () => { root.style.setProperty('--e-picker-top', Math.max(12, Math.ceil(stickyHeader.getBoundingClientRect().height) + 12) + 'px'); };
        updateOffset();
        new ResizeObserver(updateOffset).observe(stickyHeader);
      }
      function filterChoices() {
        const term = search.value.trim().toLocaleLowerCase(config.locale);
        choices.forEach(button => { button.hidden = (audience !== 'all' && button.dataset.eclatAudience !== audience) || !button.dataset.eclatName.toLocaleLowerCase(config.locale).includes(term); });
        panel.querySelector('[data-eclat-empty]').hidden = choices.some(button => !button.hidden);
      }
      search.addEventListener('input', filterChoices);
      root.querySelectorAll('[data-eclat-filter]').forEach(button => button.addEventListener('click', () => {
        audience = button.dataset.eclatFilter;
        root.querySelectorAll('[data-eclat-filter]').forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        filterChoices();
      }));
      refreshPicker = () => {
        const selected = models.find(model => model.getAttribute('aria-pressed') === 'true');
        if (!selected) return;
        Array.from(language.options).filter(option => ['wo', 'ln', 'cr-signature'].includes(option.value)).forEach(option => {
          option.disabled = !['mia', 'noah'].includes(selected.dataset.eclatCharacter);
          option.hidden = option.disabled;
        });
        choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.eclatCharacterChoice === selected.dataset.eclatCharacter)));
        languageButtons.forEach(button => {
          button.hidden = ['wo', 'ln', 'cr', 'cr-signature', 'ndjuka', 'saramaka'].includes(button.dataset.eclatLanguageChoice) && !['mia', 'noah'].includes(selected.dataset.eclatCharacter);
          button.setAttribute('aria-pressed', String(button.dataset.eclatLanguageChoice === language.value));
        });
        const base = descriptors.find(model => model.character === selected.dataset.eclatCharacter && !model.origineLanguage);
        mini.querySelector('[data-eclat-picker-summary]').textContent = base.button.dataset.eclatName + ' · ' + language.selectedOptions[0].textContent;
        miniBuy.disabled = buy?.disabled ?? true;
      };
      root.dataset.eclatPickerReady = 'true';
      filterChoices();
    } else {
      root.querySelectorAll('[data-eclat-filter]').forEach(button => button.addEventListener('click', () => {
        const audience = button.dataset.eclatFilter;
        if (!['all', 'girl', 'boy'].includes(audience)) return;
        root.querySelectorAll('[data-eclat-filter]').forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        models.forEach(model => { model.hidden = audience !== 'all' && model.dataset.eclatAudience !== audience; });
      }));
    }
    const initial = models.find(model => model.dataset.eclatName.toLowerCase() === root.dataset.eclatInitial) || models[0];
    language.value = normalizeLanguage(config.locale);
    selectModel(initial, false);
    root.dataset.eclatInitialized = 'true';
  }
  function boot(scope) { scope.querySelectorAll('[data-clairabord-eclat]').forEach(initialize); }
  if (typeof module !== 'undefined' && module.exports) module.exports = {normalizeLanguage, validPreset, formatMessage, resolveChoice, initialize};
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
    else boot(document);
    document.addEventListener('shopify:section:load', event => boot(event.target));
  }
})();
